import React from 'react';
import { useNavigate } from 'react-router-dom';

import './PermissionDenied.scss';

const PermissionDenied = () => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate('/dashboard'); // Redirect to dashboard or home
  };

  return (
    <div className="perm-denied">
      <div className="perm-denied__card">
        <div className="perm-denied__icon" aria-hidden="true">
          <span className="perm-denied__icon-glow" />
          <svg
            width="68"
            height="68"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
            <path
              d="M5.6 5.6l12.8 12.8"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <span className="perm-denied__code">403</span>
        <h1 className="perm-denied__title">Permission Denied</h1>
        <p className="perm-denied__text">
          Sorry, you don&apos;t have the required access to view this page. If you think this is a
          mistake, please contact your administrator.
        </p>

        <button type="button" className="perm-denied__btn" onClick={handleBackHome}>
          <i className="icofont-home" aria-hidden="true" />
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default PermissionDenied;
